import Route from 'rise-ui/utils/routing/route.js';

import strings from 'rise-ui/config/strings.js';
import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class TimeSeriesOutputRoute extends Route {
  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'Generate interactive plots, download machine-readable data and '
            + 'graph images, and view API request instructions for time series data '
            + 'from the Bureau of Reclamation on water, reservoir operations, water '
            + 'quality, hydropower, endangered and invasive species, and more at '
            + 'sub-hourly to annual intervals.',
        },
      },
    ];
  }

  @breadcrumb crumb = strings['time-series-output-route'];
}
